export default [
  {
    path: '/imovel',
    name: 'Imovel',
    component: () => import('./ImovelList'),
    meta: {
      routerGo: '/imovel-new',
      routerEdit: '/imovel-edit',
      routerCotas: '/imovel/:id/cotas',
      domain: 'Imovel',
      sidebar: true,
      icon: 'store_mall_directory',
      title: 'Imóvel',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/ImovelRouter.js